import { Button, Card, Col, Form, Input, message, Row, Typography } from 'antd';
import { openNotificationWithIcon } from 'app/components/PopupNotification';
import { ValidationError, ValidationSchema } from 'app/constants';
import { confirmPasswordAPI, verifyResetPwAPI } from 'app/services/api/auth';
import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useHistory, useLocation } from 'react-router-dom';
const { Text, Title } = Typography;
const NewPassword = () => {
  const history = useHistory();
  const localtion = useLocation();
  const [loading, setLoading] = useState<boolean>(false);
  const [valid, setValid] = useState<boolean | null>(null);
  const token = new URLSearchParams(localtion.search).get('token');
  const email = new URLSearchParams(localtion.search).get('email');

  const onFinish = async (e: any) => {
    setLoading(true);
    try {
      const email = new URLSearchParams(localtion.search).get('email');
      const token = new URLSearchParams(localtion.search).get('token');
      const { password, confirm } = e;
      const request = {
        email,
        newPassword: password,
        confirmPassword: confirm,
        resetCode: token,
      };
      const res = await confirmPasswordAPI(request);
      openNotificationWithIcon('success', res?.message);
      setLoading(false);
      history.push('/login');
    } catch (error: any) {
      openNotificationWithIcon('error', error?.message);
      setLoading(false);
    }
  };

  const verifyResetPw = async () => {
    const request = {
      email,
      resetCode: token,
    };
    try {
      const res = await verifyResetPwAPI(request);
    } catch (error: any) {
      openNotificationWithIcon('error', 'The link has been expired or not existed. Please reset password again!');
      history.push('/login');
    }
  };

  useEffect(() => {
    verifyResetPw();
  }, []);

  return (
    <div className="newpassword">
      <Helmet>
        <title>Reset Password</title>
      </Helmet>
      <Row className="container" justify={'center'} align={'middle'}>
        <Col className="content" sm={18} md={18} lg={12} xs={18}>
          <Card className="card">
            <Row justify={'center'} className="cardrow">
              <Col span={24} className="col_imgHeader">
                <img src="/Img/Header.png" className="img_header" alt="" />
              </Col>
              <Col sm={16} lg={16} md={16} xs={16} style={{ alignContent: 'center' }}>
                <Title className="text_title">Reset Password</Title>
                <Text type="secondary" className="text_header mt-20">
                  Set the new password for your account so you can login and access all features.
                </Text>
                <Form layout="vertical" initialValues={{ remember: true }} onFinish={onFinish} autoComplete="off">
                  <Form.Item
                    label={
                      <label className="label_form" htmlFor="new-password-input__password">
                        Enter new password
                      </label>
                    }
                    name="password"
                    rules={[
                      {
                        required: true,
                        message: 'Please enter New Password',
                      },
                      ({ getFieldValue }) => ({
                        validator(_, value) {
                          if (!value || ValidationSchema.checkPassSpecial.test(getFieldValue('password'))) {
                            return Promise.resolve();
                          }
                          return Promise.reject(new Error(ValidationError.password));
                        },
                      }),
                    ]}
                  >
                    <Input.Password
                      placeholder="Enter Your new password"
                      className="input_password"
                      id="new-password-input__password"
                    />
                  </Form.Item>
                  <Form.Item
                    label={
                      <label className="label_form" htmlFor="new-password-input__confirmPassword">
                        Retype New password
                      </label>
                    }
                    name="confirm"
                    dependencies={['password']}
                    rules={[
                      {
                        required: true,
                        message: 'Please retype Password',
                      },
                      ({ getFieldValue }) => ({
                        validator(_, value) {
                          if (!value || getFieldValue('password') === value) {
                            return Promise.resolve();
                          }
                          return Promise.reject(new Error('The new password that you entered does not match!'));
                        },
                      }),
                    ]}
                  >
                    <Input.Password
                      className="input_password"
                      placeholder="Retype New password"
                      id="new-password-input__confirmPassword"
                    />
                  </Form.Item>
                  <Col span={24}>
                    <div>
                      Use at least 8 characters with a mix of upper and lower cases, number and special characters. Must
                      not contain your name or username.
                    </div>
                  </Col>
                  <Form.Item>
                    <Button htmlType="submit" className="confirm_button" loading={loading}>
                      <Text className="text_confirm_button">Reset Password</Text>
                    </Button>
                  </Form.Item>
                </Form>
              </Col>
              <Col span={24} className="card_footer">
                <img src="/Img/Footer.png" className="img_footer" alt="" />
              </Col>
              <Text className="text_footer">© Copyright PinnacleQM 2014 - 2024. All Rights Reserved</Text>
            </Row>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default NewPassword;
